<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
        persistent
          v-model="dialog"
          width="609"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Remove Ingredient
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text">
              <v-row class="pt-8 text-center">
                <v-col cols="12">
                  <strong>Do you want to delete {{ this.ingredientName  }}</strong>
                </v-col>
              </v-row>
              <v-card-actions class="mt-10" style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn outlined class="mr-2" right depressed color="primary" @click="removeIngredient()">
                  Yes
                </v-btn>
                <v-btn right color="primary" @click="closeModal">
                  No
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>

import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";

export default {
  data() {
    return {};
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    ingredientsIdArr: {
      type: Array,
      required: true,
    },
    ingredientName: {
      type: String,
      required: true,
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    removeIngredient() {
      this.startLoading();
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($removeIngredientsInput:RemoveIngredientsInput!) {
                removeIngredients(removeIngredientsInput:$removeIngredientsInput){
                  success
                  message
                }
            }
          `,
          variables: {
            removeIngredientsInput: {
              idArr: this.ingredientsIdArr
            }
          },
        })
       
        
        .then(({data})=> {
          console.log('data',data);
          if(data.removeIngredients.success === true) {
            this.$emit("removeIngredientSuccess");
            this.stopLoading();
              this.$notify({
                title: "Ingredient removed",
                text: data.removeIngredients.message || "Ingredient removed successfully.",
                type: "success",
              });
              this.$emit("closeDialog");
          } else {
            this.stopLoading();
              this.$notify({
                title: "Error in removing product",
                text: data.removeIngredients.message,
                type: "error",
              });
              this.$emit("closeDialog");
          }
        })
        .catch((err) => {
          console.log("err", err.response);
          this.$emit("closeDialog");
          this.stopLoading();
        })
    }
  },
  mixins:[loadingMixin]
};
</script>

<style></style>
